/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import gridConfig from '../../common/tableConfig/gridConfig'
import { convertColumndef, convertRowData } from '../../common/tableConfig/studentAssessmentConfig';
import style from '../../styles.module.scss';
import { EDWDropDown } from "../common/dropDown/DropDown";
import { sortByKey } from "../../common/utils";

export default class AssessmentTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coloumnDef: [],
            rowData: [],
            icons: props.assessmentConfig.icons,
            height: props.height,
            assessmentConfig: props.assessmentConfig,
            viewBy: props.viewBy,
            defaultColDef: gridConfig.defaultColDef
        };
    }
    componentDidMount() {
        this.generateGridConfig(this.state.assessmentConfig, this.state.viewBy)
    }
    componentDidUpdate() {
         this.props.updateExportData({ type: "student_widget_2", rowData: this.state.rowData,columnDefs:this.state.coloumnDef});
    }
    generateGridConfig(assessmentConfig, viewBy) {
        let columndef = convertColumndef(viewBy, assessmentConfig);
        let rowData = convertRowData(assessmentConfig);
        let height = 100 + (parseInt(rowData.length) * 70);
        this.setState({ rowData: rowData, coloumnDef: columndef, height: height });
        this.props.updateExportData({ type: "student_widget_2", rowData: this.state.rowData,columnDefs:this.state.coloumnDef});
    }
    sortByView = (value) => {
        if(value !=this.state.viewBy){
            this.setState({ viewBy: value });
            this.generateGridConfig(this.state.assessmentConfig, value);
            this.gridApi.setColumnDefs(this.state.columndef);
        }        
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.refreshCells(params);
        this.gridApi.setColumnDefs(this.state.coloumnDef);
    };
    onColumnResized=(params)=> {
      this.gridApi = params.api;
         this.gridApi.resetRowHeights();
    }
    isKs4 = data => {
        return data && data.toLowerCase().indexOf('edexcel') > -1
    }
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        let sortedRowData = sortByKey(this.state.rowData, sortModel[0]["colId"]);
        this.setState({ rowData: sortedRowData });
    }  
    render() {
        const isKs4 = this.isKs4(this.props.courseName || '');
        return (
            <div>

                <div className="col">
                    <div className="row contentFilter">
                        <div className="col-md-4 "></div>
                        <div className="col-md-4"></div>
                        { 
                            !isKs4 && (
                            <div className="col-md-4 ">
                                        <label className={style.lblColor}>Show</label>
                                        <EDWDropDown
                                            items={[{ label: 'Indicative grade', id: 'indicativeGradeValue' }, { label: 'Steps', id: 'stepValue' }]}
                                            onChange={this.sortByView}
                                            label="Show"
                                            value={this.state.viewBy}
                                        />
                                    </div>
                            )
                        }
                        
                    </div>

                </div>
                <div className="ag-theme-alpine" id="blind" style={{ height: '', width: 'auto' }}>
                    <AgGridReact tooltipShowDelay={0}
                        columnDefs={this.state.coloumnDef}
                        rowData={this.state.rowData}
                        icons={this.state.icons}
                        onGridReady={this.onGridReady}
                        onCellClicked={this.props.onCellClick}
                        domLayout="autoHeight"
                        onColumnResized={this.onColumnResized}
                        defaultColDef={this.state.defaultColDef}
                        onSortChanged={this.onSortChanged.bind(this)}
                    >
                    </AgGridReact>
                </div>
            </div>
        )
    }
}